//# sourceMappingURL=origin.mjs.map
/// <reference types="./origin.d.mts" />
import * as $json from "../../../gleam_json/gleam/json.mjs";
import * as $decode from "../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import { Ok, Error, CustomType as $CustomType } from "../../gleam.mjs";

/**
 * Created in the application: the import wizard, the proposal builder.
 */
export class App extends $CustomType {}
export const Origin$App = () => new App();
export const Origin$isApp = (value) => value instanceof App;

/**
 * Pushed by the browser extension.
 */
export class Extension extends $CustomType {}
export const Origin$Extension = () => new Extension();
export const Origin$isExtension = (value) => value instanceof Extension;

/**
 * Created from a portal integration.
 */
export class Portal extends $CustomType {}
export const Origin$Portal = () => new Portal();
export const Origin$isPortal = (value) => value instanceof Portal;

/**
 * Written through the MCP server by an external model.
 */
export class Mcp extends $CustomType {}
export const Origin$Mcp = () => new Mcp();
export const Origin$isMcp = (value) => value instanceof Mcp;

export function to_string(origin) {
  if (origin instanceof App) {
    return "app";
  } else if (origin instanceof Extension) {
    return "extension";
  } else if (origin instanceof Portal) {
    return "portal";
  } else {
    return "mcp";
  }
}

export function from_string(origin) {
  if (origin === "app") {
    return new Ok(new App());
  } else if (origin === "extension") {
    return new Ok(new Extension());
  } else if (origin === "portal") {
    return new Ok(new Portal());
  } else if (origin === "mcp") {
    return new Ok(new Mcp());
  } else {
    return new Error(undefined);
  }
}

/**
 * Decodes a known origin, and treats an unknown one as *unrecorded* rather
 * than failing: a proposal written by a newer version of Steerlab must not
 * become undecodable to an older reader — the browser extension decodes
 * proposals too, and it ships on its own release cycle.
 */
export function decoder() {
  return $decode.then$(
    $decode.string,
    (origin) => {
      let $ = from_string(origin);
      if ($ instanceof Ok) {
        let origin$1 = $[0];
        return $decode.success(origin$1);
      } else {
        return $decode.failure(new App(), "Origin");
      }
    },
  );
}

export function encode(origin) {
  return $json.string(to_string(origin));
}
